import Brand from "./images/brand.svg";
import Diversify from "./images/diversify.svg";
import Network from "./images/network.svg";
import PartnerInvestment from "./images/partner-investment.svg";
import Growth from "./images/growth.svg";
import Profit from "./images/profit.svg";

export const FRANCHISE_WHY_CARS = [
    {
        icon: Profit,
        title: "Profit Potential",
        subTitle: "of Up to",
        description: "5L/month"
    },
    {
        icon: Growth,
        title: "Used car market",
        subTitle: "growth of",
        description: "20% Yearly"
    },
    {
        icon: Network,
        title: "Access to a",
        subTitle: "network of",
        description: "20,000+ Dealers"
    },
    {
        icon: Brand,
        title: "Trusted brand:",
        subTitle: "annually catering",
        description: "2L Sellers"
    },
    {
        icon: PartnerInvestment,
        title: "Return of",
        subTitle: "investment in",
        description: "3 Months"
    },
    {
        icon: Diversify,
        title: "Diversify your",
        subTitle: "income via",
        description: "10+ Services"
    }
];
